import { render, staticRenderFns } from "./SubAccount.vue?vue&type=template&id=6a11d24e&scoped=true"
import script from "./SubAccount.vue?vue&type=script&lang=js"
export * from "./SubAccount.vue?vue&type=script&lang=js"
import style0 from "./SubAccount.vue?vue&type=style&index=0&id=6a11d24e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a11d24e",
  null
  
)

export default component.exports